<template>
<div class="login">
<v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field prepend-icon="person" v-model="email" name="email" label="email" type="text"></v-text-field>
                  <v-text-field prepend-icon="lock" v-model="password"  name="password" label="Password" id="password" type="password"></v-text-field>
                      <p class="text-xs-center" v-if="feedback">{{feedback}}</p>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login()">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</div>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/auth';
export default {
    name:'Login',
    data(){
        return{
            email:null,
            password:null,
            feedback:null
        }
    },
    methods:{
        login(){
          if(this.email && this.password){
            console.log(this.email,this.password)
               firebase.auth().signInWithEmailAndPassword(this.email,this.password).then(cred=>{
                 //  console.log(cred.user)
                 
                   this.$router.push({name:'Stable'})
               }).catch(err=>{
                    this.feedback=err.message
                  //  console.log(err.message)
               })
               this.feedback=null
           }
           else{
               this.feedback='plase fill in both '
           }
        }
    }
}
</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Login.vue